module.exports = __webpack_public_path__ + "img/rafael_green.91667b72.jpg";